import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { MenuService } from 'src/app/components/menu/menu.service';
import { AuthService } from '../services/auth.service';
import { RolesUsuario } from '../enumeraciones/roles-usuario.enum';

@Injectable()
export class AuthGuardService implements CanActivate {

	constructor(public authService: AuthService, public router: Router, private menuService: MenuService) { }

	canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
		if (!this.authService.isToken()) {
			this.router.navigate(['home']);
			return new Observable<Boolean>().pipe(
				map(() => false)
			);
		}
		return this.menuService.get(null).pipe(
			map(resultado => {
				if (resultado.result && resultado.data) {
					// const isRol = (resultado.data.filter(e => state.url.startsWith(e.ruta_url))).length > -1;
					// if (!isRol) {
					// 	this.router.navigate([resultado.data[0].ruta_url]);
					// 	return false;
					// }
					if (next.data.roles) {
						const rol = (next.data.roles as Array<RolesUsuario>).find(dato => this.authService.getRolUser(dato) !== null);
						if (!rol) {
							this.router.navigate([resultado.data.horizontal[0].ruta_url]);
							// if (resultado.data.horizontal) {
							// 	this.router.navigate([resultado.data.horizontal[0].ruta_url]);
							// } else {
							// 	this.router.navigate([resultado.data.vertical[0].ruta_url]);
							// }
							return false;
						}
					}
					this.menuService.setRoles(resultado.data);
					return true;
				}
			})
		);
	}
}
